import styles from "./Info.module.scss";
import classNames from "classnames";

type InfoProps = {
  title: string;
  description: string;
  element?: JSX.Element;
  shortInfo?: JSX.Element;
  steps?: JSX.Element;
  blendMode?: boolean;
};

export const Info = ({
  title,
  description,
  element,
  shortInfo,
  steps,
  blendMode = false,
}: InfoProps) => {
  return (
    <div
      className={classNames(styles.wrapper, { [styles.blendMode]: !blendMode })}
    >
      <div className={styles.top}>
        <div className={styles.leftSide}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.button}>{element}</div>
      </div>
      <div className={styles.bottom}>{shortInfo || steps}</div>
    </div>
  );
};
